import Box from '@mui/material/Box';
import { Cell, Pie, PieChart } from 'recharts';
import Typography from '@mui/material/Typography';

interface Props {
    values: number[];
    isLoadingData: boolean;
    onlyOne?: boolean;
}

const PieChartBlock = ({ values, isLoadingData, onlyOne = false }: Props) => (
    <Box
        sx={{
            position: 'relative',
            width: 170,
            height: 170,
        }}
    >
        <Box
            sx={{
                transform: 'rotate(-90deg)',
            }}
        >
            <PieChart width={170} height={170}>
                <Pie
                    data={[
                        {
                            name: 'empty',
                            value: isLoadingData
                                ? 1
                                : values[0] === 0
                                  ? onlyOne
                                      ? 100
                                      : values[1] || 100
                                  : onlyOne
                                    ? Math.max(0, (values[1] || 100) - values[0])
                                    : Math.max(0, (values[1] || 0) - values[0]),
                        },
                        { name: 'fill', value: isLoadingData ? 0 : Math.max(0, values[0] || 0) },
                    ]}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={85}
                    paddingAngle={1.5}
                    dataKey="value"
                >
                    <Cell fill={'#CDD0DA'} />
                    <Cell fill={values[0] === 0 ? '#CDD0DA' : '#505EB6'} />
                </Pie>
            </PieChart>
        </Box>

        <Box
            sx={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                display: 'grid',
                placeContent: 'center',
            }}
        >
            <Typography
                sx={{
                    fontWeight: 700,
                }}
            >
                {onlyOne && (isLoadingData ? '-' : values[0])}

                {!onlyOne && (isLoadingData ? '-/-' : `${values[0]}/${values[1]}`)}
            </Typography>
        </Box>
    </Box>
);

export default PieChartBlock;
